import type { SubscriptionFrequency } from "./SubscriptionFrequency.js";
import type { SubscriptionSize } from "./SubscriptionSize.js";
import { subscriptionFrequencyToWeeksMap } from "./utils/subscriptionFrequencyToWeeksMap.js";
import { subscriptionSizeToAmountMap } from "./utils/subscriptionSizeToAmountMap.js";
import { subscriptionSizeToWeightMap } from "./utils/subscriptionSizeToWeightMap.js";

// FCR-466 Temporary: the Mother’s Blend subscription price is taken from this constant instead of the
// product’s DB price (mirrors Father’s Choice). Values are the per-bag price WITHOUT tax in CZK;
// the per-size discount (5 % / 15 %) and tax are applied downstream.
const mothersBlendPriceByWeight: Record<(typeof subscriptionSizeToWeightMap)[SubscriptionSize], number> = {
	250: 290,
	1000: 1009,
};

/**
 * Returns the reference retail price without tax for a Mother’s Blend product.
 *
 * - Without `frequency`: per-unit price (one bag of the given weight).
 * - With `frequency`: normalized monthly price (all units, amortised over a month).
 */
export function getMothersBlendPrice(size: SubscriptionSize, frequency?: SubscriptionFrequency): number {
	const weight = subscriptionSizeToWeightMap[size];
	const unitPrice = mothersBlendPriceByWeight[weight];

	if (frequency === undefined) {
		return unitPrice;
	}

	const amount = subscriptionSizeToAmountMap[size];
	const weeks = subscriptionFrequencyToWeeksMap[frequency];
	return ((365 / (weeks * 7)) * (unitPrice * amount)) / 12;
}
